export default __webpack_public_path__ + "static/media/bakery-worker.39df7674.svg";